import { render, staticRenderFns } from "./RoundedButtons.vue?vue&type=template&id=1d258efe&"
import script from "./RoundedButtons.vue?vue&type=script&lang=js&"
export * from "./RoundedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports